const careerAf = {
	breadcrumbs: { home: 'کور', career: 'مسلک' },
	hero: {
		title: 'خپل خوب مسلک پیل کړئ',
		subtitle: 'د ګرامین بازار سره یوځای شئ او د بنګله دېش په کلیوالي سوداګرۍ کې د ډیجیټل دورې ته د بدلون کې مرسته وکړئ'
	},
	companyStats: [
		{ value: '500+', label: 'کارمندان' },
		{ value: '10+', label: 'دفترونه' },
		{ value: '98%', label: 'د کارمندانو رضایت' },
		{ value: '100+', label: 'د روزنې پروګرامونه' }
	],
	jobsSection: { title: 'خلاص ځایونه', subtitle: 'له موږ سره کار وکړئ او خپل مسلک وده ورکړئ' },
	labels: {
		featured: 'ځانګړی',
		postedSuffix: 'خپور شوی',
		salary: 'معاش',
		deadline: 'د غوښتنلیک وروستی نیټه'
	},
	buttons: {
		viewDetails: 'تفصیلات وګورئ',
		apply: 'غوښتنه',
		cancel: 'لغوه کول',
		submit: 'غوښتنلیک سپارل',
		contact: 'موږ سره اړیکه ونیسئ'
	},
	cta: {
		title: 'مناسب ځای و نه موندل شو؟',
		subtitle: 'موږ سره اړیکه ونیسئ. موږ به تاسو ته د نوي فرصتونو په اړه خبر ورکړو.',
		contact: 'موږ سره اړیکه ونیسئ'
	},
	form: {
		titleSuffix: ' - د غوښتنلیک فورمه',
		name: 'نوم',
		email: 'بریښنالیک',
		phone: 'تلیفون',
		education: 'زده کړه',
		experience: 'د کار تجربه',
		uploadResume: 'د CV اپلوډ (PDF, DOC, DOCX)'
	},
	snackbar: {
		success: 'ستاسو غوښتنلیک سپارل شوی دی. موږ به ژر تاسو سره اړیکه ونیسو.'
	},
	jobs: [
		{
			id: 1,
			title: 'د سافټویر انجنیر',
			department: 'IT',
			location: 'ډاکه',
			type: 'پوره وخت',
			experience: '5+ کلونه',
			salary: '80,000 - 120,000 ټکا',
			deadline: '30 اپریل، 2024',
			posted: '5 ورځې دمخه',
			description: 'زموږ د ټیک ټیم سره یوځای شئ. د React، Node.js او Cloud خدماتو تجربه اړینه ده.',
			requirements: ['لږترلږه 5 کلونه د ویب پراختیا', 'په React، Node.js کې قوي', 'د AWS/GCP تجربه', 'د ټیم مشرۍ تجربه'],
			benefits: ['د سیالي وړ معاش', 'د روغتیا بیمه', 'کلنی بونس', 'د کار د ساعتونو انعطاف'],
			featured: true
		},
		{
			id: 2,
			title: 'د بازارموندنې مدیر',
			department: 'بازارموندنه',
			location: 'ډاکه',
			type: 'پوره وخت',
			experience: '3+ کلونه',
			salary: '50,000 - 80,000 ټکا',
			deadline: '25 اپریل، 2024',
			posted: '3 ورځې دمخه',
			description: 'د ډیجیټل کمپاینونو د پلان او پلي کولو لپاره د تجربه لرونکی بازارموندنې مدیر ته اړتیا ده.',
			requirements: ['3+ کلونه په ډیجیټل بازارموندنه کې', 'د ټولنیزو کمپاینونو د چلولو تجربه', 'د ټیم مدیریت مهارتونه', 'د بودیجې د سمبالولو تجربه'],
			benefits: ['د سیالي وړ معاش', 'د روغتیا بیمه', 'د زده کړې بودیجه'],
			featured: false
		},
		{
			id: 3,
			title: 'د پیرودونکو خدمت اجرائیه',
			department: 'د پیرودونکو خدمت',
			location: 'ډاکه',
			type: 'پوره وخت',
			experience: '1+ کال',
			salary: '25,000 - 40,000 ټکا',
			deadline: '20 اپریل، 2024',
			posted: '1 ورځ دمخه',
			description: 'د ځانګړي پیرودونکو ملاتړ لپاره د انرژي او تجربه لرونکی شخص.',
			requirements: ['1+ کال په پیرودونکو خدمت کې تجربه', 'ممتاز اړیکه', 'په بنګله او انګلیسي کې روان', 'د کمپیوټر مهارتونه'],
			benefits: ['د سیالي وړ معاش', 'د روغتیا بیمه', 'د مسلک وده'],
			featured: false
		}
	]
};

export default careerAf;
